export default __webpack_public_path__ + "static/media/grayMinus.3ca97ca5.svg";